import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  /** Edit mode baseline for METADATA / ITEMS / BOTH diffing; null when creating or unset */
  baseline: null,
  /** Unsaved change state for Step 3 inline catalog editor (ProductBuilder). */
  catalogBuilderDirty: false,
  /** Products array — source of truth for catalog items during editing */
  products: [],
  /** Services array — source of truth for catalog items during editing */
  services: [],
};

const bizEditSlice = createSlice({
  name: "bizEdit",
  initialState,
  reducers: {
    setBizEditBaseline(state, action) {
      state.baseline = action.payload;
    },
    clearBizEditBaseline(state) {
      state.baseline = null;
      state.catalogBuilderDirty = false;
    },
    setCatalogBuilderDirty(state, action) {
      state.catalogBuilderDirty = !!action.payload;
    },
    clearCatalogBuilderDirty(state) {
      state.catalogBuilderDirty = false;
    },
    setCatalogProducts(state, action) {
      state.products = action.payload;
    },
    setCatalogServices(state, action) {
      state.services = action.payload;
    },
    updateCatalogItem(state, action) {
      const { type, index, data } = action.payload;
      if (type === "products" && Array.isArray(state.products)) {
        state.products[index] = { ...state.products[index], ...data };
      } else if (type === "services" && Array.isArray(state.services)) {
        state.services[index] = { ...state.services[index], ...data };
      }
    },
  },
});

export const {
  setBizEditBaseline,
  clearBizEditBaseline,
  setCatalogBuilderDirty,
  clearCatalogBuilderDirty,
  setCatalogProducts,
  setCatalogServices,
  updateCatalogItem,
} = bizEditSlice.actions;
export default bizEditSlice.reducer;
